export const FROV_SIGN = 'frovsign';

export const FROV_NAME = "ФРОВ";
export const NEFROV_NAME = "НЕФРОВ";
